import ConfirmationBoxView  from './confirmation-box-view'
import ConfirmationBoxContext from './confirmation-box-context'

export default ConfirmationBoxView

export { ConfirmationBoxContext }
